import './TypingDots.scss'

import { PrimitiveAtom, useAtom } from 'jotai'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { chatProgressMessageAtom, isServerRespondingAtom } from '@/store/gigiChat/ChatAtom'

const TypingDots = () => {
    const [isServerResponding] = useAtom<PrimitiveAtom<boolean>>(isServerRespondingAtom)
    const [chatProgressMessage] = useAtom<string | null>(chatProgressMessageAtom)

    if (chatProgressMessage === null) {
        return null
    }

    return (
        isServerResponding && (
            <Flex w="100%" mt="5px" mb="16px" alignItems="center">
                <Flex justifyContent="center" alignItems="center" alignContent="center" className="stage">
                    <Box className="dot-typing"></Box>
                </Flex>
                <Text className="chat-progress-message" fontSize="12px">
                    {chatProgressMessage && `${chatProgressMessage}...`}
                </Text>
            </Flex>
        )
    )
}

export default TypingDots
